<template>
  <nav>
    <div
      class="fill-height"
      :class="mobileOverride() ? 'activity-page-container-mobile' : 'activity-page-container'"
    >
      <AlertMessages
        v-if="alertValue"
        :alert-type="alertType"
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />

      <!-- show draft tag -->
      <v-row
        v-if="!published && role == 'booster' && !loadingData && !mobile()"
        no-gutters
        class="text-right custom-draft-tag custom-draft-tag-style-more-right"
      >
        <v-col cols="12">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-chip
                data-testid="draft-available-chip"
                color="warning"
                text-color="black"
                v-on="on"
              >
                {{ $t("draftScormAvailableTag") }}
              </v-chip>
            </template>
            <span>{{ $t("draftScormAvailableTooltip") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <!-- booster view -->
      <v-row
        v-if="!loadingData && role == 'booster'"
        class="greyactivitybackground fill-height"
        no-gutters
      >
        <v-col
          cols="12"
          :class="!mobile() ? 'fill-height px-3 mr-n2' : 'fill-height mr-n2'"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px' : ''"
        >
          <div class="text-center d-none d-md-block">
            <ActivityViewToggle @toggleView="changeView"/>
          </div>
          <v-tabs
            v-model="tabs"
            right
            slider-color="white"
            slider-size="0px"
            :background-color="!mobile() ? 'greyactivitybackground' : ''"
            active-class="tab-version-active"
            class="mx-auto fill-height view-scorm overflow-hidden"
            data-testid="show-tabs"
            :class="screen"
          >
            <v-tab
              href="#publish"
              v-if="published"
              v-show="!mobile()"
              style="border-radius: 8px 8px 0 0"
              class="tab-version publish"
              data-testid="published-tab"
            >
              {{ $t('published') }}
            </v-tab>
            <v-tab
              href="#draft"
              v-if="!published"
              v-show="!mobile()"
              style="color: #fbc02d; border-radius: 8px 8px 0 0"
              class="tab-version draft"
              data-testid="draft-tab"
            >
              {{ $t('draft') }}
            </v-tab>

            <v-tabs-items v-model="tabs" :class="!mobile() ? 'rounded-xxl' : 'fill-height'">
              <v-tab-item
                v-if="published"
                value="publish"
                key="publish"
                :transition="false"
                reverse-transition="false"
                :style="!mobile() ? 'border: 2px solid #F4F5F5;' : ''"
                :class="mobile() ? 'fill-height' : ''"
                data-testid="published"
              >
                <!-- eslint-disable vue/no-v-html -->
                <v-card 
                  v-if="scormPackage != null"
                  elevation="0"
                  class="py-12 mx-auto fill-height scorm-player rounded-xxl"
                  width="100%"
                  :height="!mobile() ? '650' : ''"
                  data-testid="view-scorm"
                  :class="screen == 'mobile-view' ? 'mobile-view-simulator' : ''"
                >
                  <iframe :src="scormPackage" style="border: none" />
                </v-card>
                <EmptyPageActivity v-else
                  elevation="0"
                  class="mx-auto fill-height"
                  align="center"
                  :page-title="$t('emptyActivityScormTitle')"
                  :page-text="$t('emptyActivityScormText')"
                  page-image="image4"
                  :class="screen == 'mobile-view' ? 'mobile-view-simulator' : ''"
                />
              </v-tab-item>
              <v-tab-item
                v-if="!published"
                value="draft"
                key="draft"
                :transition="false"
                reverse-transition="false"
                :class="!mobile() ? 'rounded-xxl' : ''"
                :style="!mobile() ? 'border: 2px solid #fbc02d;' : ''"
                data-testid="draft"
              >
                <!-- eslint-disable vue/no-v-html -->
                <v-card
                  v-if="scormPackage != null"
                  elevation="0"
                  class="py-12 mx-auto fill-height scorm-player rounded-xxl"
                  width="100%"
                  :height="!mobile() ? '650' : ''"
                  data-testid="view-scorm"
                  :class="screen == 'mobile-view' ? 'mobile-view-simulator' : ''"
                >
                  <iframe :src="scormPackage" style="border: none" />
                </v-card>
                <EmptyPageActivity v-else
                  elevation="0"
                  class="mx-auto fill-height"
                  align="center"
                  :page-title="$t('emptyActivityScormTitle')"
                  :page-text="$t('emptyActivityScormText')"
                  page-image="image4"
                  :class="screen == 'mobile-view' ? 'mobile-view-simulator' : ''"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-col>
      </v-row>
      <!-- end booster view -->
      <!-- view scorm not booster -->
      <v-row
        v-if="role != 'booster' && !loadingData && !noPublishedItems && !isAuth"
        class="greyactivitybackground fill-height"
        no-gutters
      >
        <v-col
          cols="12"
          class="fill-height mr-n2"
          :class="!mobile() ? 'px-3' : ''"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px' : ''"
        >
          <LockActivityPage
            max-width="960px"
            elevation="0"
            class="mx-auto fill-height"
            align="center"
            data-testid="lockactivitypage"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="noPublishedItems == true && !loadingData && role != 'booster'"
        class="fill-height"
        align="center"
      >
        <v-col
          cols="12"
          class="mr-n2"
          :class="!mobile() ? 'px-3' : ''"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px' : ''"
          align="center"
        >
          <EmptyPage
            :page-title="$t('noPublishedItemsTitle')"
            :page-text="$t('noPublishedItemsText')"
            page-image="image4"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="!loadingData && lockedContent && !noPublishedItems && role != 'booster'"
        class="greyactivitybackground fill-height"
        align="center"
        no-gutters
      >
        <v-col
          cols="12"
          class="fill-height mr-n2"
          :class="!mobile() ? 'px-3' : ''"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px' : ''"
        >
          <LockedContent
            max-width="960px"
            elevation="0"
            class="fill-height"
            :content="requiredContent"
            :type="lockType"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="scormPackage != null && !loadingData && isAuth && role != 'booster'"
        class="greyactivitybackground fill-height"
        no-gutters
      >
        <v-col
          cols="12"
          class="fill-height mr-n2"
          :class="!mobile() ? 'px-3' : ''"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px' : ''"
        >
          <v-card    
            max-width="960px"
            elevation="0"
            class="mx-auto fill-height  scorm-player"
            :class="!mobile() ? 'rounded-xxl py-12' : 'pb-12'"
            width="100%"
            height="100%"
            data-testid="view-scorm"
          >
            <iframe
              :src="scormPackage"
              style="border:none"
            />

             <!-- <scorm-player
                  path="/scorm" 
                  @commit="commit"
                  @finish="finish"
                  @get-diagnostic="getDiagnostic"
                  @get-error-string="getErrorString"
                  @get-last-error="getLastError"
                  @get-value="getValue"
                  @initialize="initialize"
                  @set-value="setValue"
                />  -->
          </v-card>
        </v-col>
      </v-row>
      
      <!-- end not booster view -->

      <v-card
        ref="viewNavigationButtons"
        max-width="960px"
        elevation="0"
        class="mx-auto"
        v-if="role != 'booster' && !loadingData"
      >
        <NavigationBackButton
          :activity-pages="activity_pages"
        />
        <NavigationNextButton
          :activity-pages="activity_pages"
        />
      </v-card>

      <EditButtonWithLinkInActivity
        v-if="isAuth && role == 'booster' && !loadingData && !mobile()"
        data-testid="edit-scorm-button"
        rounded="xxl"
        :class="editButtonTextColor"
        :color="editButtonColor"
        :link="{title: '',route:'/activity/' + $route.params.id +'/scorm/' + $route.params.scormId + '/edit',}"
        :classes="'edit-activity'"
        @openPreventEditingDialog="dialogVisible = true"
      />
      <ConfirmationDialog
        v-if="dialogVisible"
        ref="confirmationDialog"
        :visible="dialogVisible"
        :cd-title="confirmationDialogTitle"
        :cd-text="confirmationDialogText"
        :cd-submit-btn="confirmationDialogSubmitBtn"
        :cd-cancel-btn="confirmationDialogCancelBtn"
        :cd-submit-btn-color="cdSubmitBtnColor"
        data-testid="confirmation-dialog"
        @close="dialogVisible = false"
        @proceedSubmit="dialogVisible = false"
      />
    </div>
  </nav>
</template>

<script>
import i18n from '../../plugins/i18n'
import { getActivity, getActivityPages, getActivityScorm } from '../../api/activityApi'
import {eventBus} from '../../eventbus'
import EmptyPage from '../../components/EmptyPage'
import EmptyPageActivity from '../../components/EmptyPageActivity'
import NavigationNextButton from '../../components/NavigationNextButton'
import EditButtonWithLinkInActivity from '../../components/EditButtonWithLinkInActivity'
import AlertMessages  from '../../components/AlertMessages'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import LockActivityPage from '../../components/LockActivityPage'
import LockedContent from '../../components/LockedContent'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import moment from 'moment'
import NavigationBackButton from '../../components/NavigationBackButton'
import ActivityViewToggle from '../../components/ActivityViewToggle'

export default {
    components: {
        EmptyPage,
        EmptyPageActivity,
        NavigationNextButton,
        EditButtonWithLinkInActivity,
        AlertMessages,
        LockActivityPage,
        LockedContent,
        ConfirmationDialog,
        NavigationBackButton,
        ActivityViewToggle
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            isAuth: window.$cookies.get("token")? true: false,
            checkboxCertificate: false,
            loadingData: false,
            spaceId: window.$cookies.get('space_id'),
            activityId: this.$route.params.id,
            pageId: this.$route.params.pageId,
            quizId: this.$route.params.quizId,
            scormId: this.$route.params.scormId,
            alertMsg: '',
            alertValue:false,
            alertType: '',
            activity_pages: [],
            scormPackage: null,
            isLoggedIn:true,
            role:'',
            published: false,
            editButtonColor: 'warning',
            editButtonTextColor: 'black--text',
            noPublishedItems: false,
            lockedContent: false,
            requiredContent: {},
            pageExist: true,
            dialogVisible: false,
            confirmationDialogTitle: i18n.t('confirmationDialogTitlePreventEdit'),
            confirmationDialogText: i18n.t('confirmationDialogTextPreventEdit'),
            confirmationDialogSubmitBtn: i18n.t('ok'),
            confirmationDialogCancelBtn: i18n.t('cancel'),
            cdSubmitBtnColor: 'accent',
            showForum: true,
            tabs: 'publish',
            lockType: null,
            screen: 'desktop-view'
        }
    },
    async beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.getPrevRoute(from);
        })
    },
    async beforeRouteLeave(to, from, next){
        if (this.role == 'participant' || this.role == 'guest') {
            eventBus.$emit('checkUpdates', true, this.checkboxCertificate)
        }
        next();
    },
    
    async created(){  
        if (window.$cookies.get("token") == null) {
            this.isLoggedIn = false
        }

        if(this.$route.params.successfullyCreatedActivity){
            this.alertMsg = i18n.t('createActivitySuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyCreatedActivityPage){
            this.alertMsg = i18n.t('createActivityPageSuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyCreatedActivityQuiz){
            this.alertMsg = i18n.t('createActivityQuizSuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyAddedActivityScorm){
            this.alertMsg = i18n.t('createActivityScormSuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyCreatedActivityChecklist){     
            this.alertMsg = i18n.t('createActivityChecklistSuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyCreatedActivitySurvey){     
            this.alertMsg = i18n.t('createActivitySurveySuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyUpdatedActivityPage){
            this.alertMsg = i18n.t('editActivityPageSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyUpdatedActivityScorm){
            this.alertMsg = i18n.t('publishScormSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullySharedActivity){
            this.alertMsg = i18n.t('shareActivitySuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivityPage){
            this.alertMsg = i18n.t('deleteActivityPageSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivityQuiz){
            this.alertMsg = i18n.t('deleteActivityQuizSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivityScorm){
            this.alertMsg = i18n.t('deleteActivityScormSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivityChecklist){
            this.alertMsg = i18n.t('deleteActivityChecklistSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivitySurvey){
            this.alertMsg = i18n.t('deleteActivitySurveySuccess')
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyDuplicatedActivity){     
            this.alertValue = true
            this.alertType = 'success'
            this.alertMsg =  i18n.t('duplicateActivitySuccess')
        }

        if(this.$route.params.boostersAddedInActivity){
            this.alertMsg = i18n.t('addActivityBoostersSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }

        if (this.$route.params.successfullyConnectedActivityEduAdmin) {
            this.alertMsg = i18n.t("eduAdminConnectedActivitySuccess");
            this.alertType = "success";
            this.alertValue = true;
        }

        if(this.$route.params.preventEditing){
            this.dialogVisible = true
        }

        this.loadingData = true
        this.lockedContent = false
        this.scormId = this.$route.params.scormId

        await this.getActivityPages()

        await this.getActivity()

        if (this.role == 'participant' || this.role == 'guest') {
            //reset navigation
            eventBus.$emit('changeNavigationInActivity', this.activity_pages)          
        }

        this.loadingData = false
    },

    methods:{
        mobileOverride(){
            if(this.screen == 'mobile-view'){
                return true;
            }else{
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
            }
        },
        changeView(val){
            this.screen = val
        },
        getPrevRoute(data){
          if(data.name == 'Activitites' || data.name == 'ViewHub' || data.name == 'ViewCategory' || data.name == 'SharedWithMe'  ||  data.name == 'Dashboard' || data.name == 'AllActivitiesParticipant' || data.name == 'AllHubsParticipant' ||  data.name == 'ActivitiesParticipant'){
            eventBus.$emit('setActivityExitBtn',data)
          }
        },

        async getActivity(){
            try {
                const response = await getActivity(this.activityId)
                if(response.status == 200) {
                  this.role = response.data.data.attributes.role

                  if (response.data.data.attributes.activity_page_id == null) {
                        this.noPublishedItems = true
                    } else {
                        if (!this.pageExist) {
                            this.$router.push({name: 'PageNotFound'})
                        } else if (this.role != 'booster' && !this.published) {
                            this.$router.push({name: 'PageAccessDenied'})
                        }
                        if(this.role && this.role != "NA" ){
                            if (this.role == 'booster' ||  ((this.role == 'participant' || this.role == 'guest') && !this.lockedContent)){
                                const response_scorm = await getActivityScorm(this.scormId)
                                if(response_scorm.status == 200) {
                                    this.published = response_scorm.data.data.attributes.published
                                    this.editButtonColor = this.published ? "accent" : "warning"
                                    this.editButtonTextColor = this.published ? "white--text" : "black--text"
                                    this.checkboxCertificate = response.data.data.attributes.certificate_enabled
                                    if(response_scorm.data.data.attributes.url != null){
                                        this.scormPackage = process.env.VUE_APP_API_IFRAME_URL + '/activity/' + this.activityId + '/scorm/' + this.scormId + '/' + window.$cookies.get("token");
                                    }else {
                                        this.scormPackage = null
                                    }
                                }
                            }
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        if(this.isAuth){
                            this.$router.push({name: 'PageNotFound'})
                        }else{
                            this.$router.push({name: 'CustomLogin', query: {referer: this.$route.fullPath}})
                        }
                    }else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    }else if(e.response.status != 401) {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                } 
            }
        },
        async getActivityPages(){
            try {
                const response = await getActivityPages(this.activityId)
                if (response.status == 200) {
                    if (!response.data.data.find(page => page.attributes.entity_id == this.scormId && page.attributes.entity_type == 'scorm')) {
                        this.pageExist = false
                    }
                    this.activity_pages = response.data.data.filter(page => page.attributes.is_published == true)
                    if(this.activity_pages.find(page => page.attributes.entity_id == this.scormId && page.attributes.entity_type == 'scorm')) {
                        this.published = true
                    }
                    var requiredPageId = this.activity_pages.find(page => page.attributes.entity_id == this.scormId && page.attributes.entity_type == 'scorm').attributes.rule_item_id
                    var requiredPageStatus = this.activity_pages.find(page => page.attributes.entity_id == this.scormId && page.attributes.entity_type == 'scorm').attributes.rule_fulfilled
                    var requiredDate = this.activity_pages.find(page => page.attributes.entity_id == this.scormId && page.attributes.entity_type == 'scorm').attributes.rule_available_after
                    
                    if(requiredPageId != null && requiredPageStatus == false){
                        this.lockedContent = true
                        this.requiredContent = this.activity_pages.find(page => page.id == requiredPageId)
                        this.lockType = "feedItemDependent"
                    }else if(requiredDate != null && requiredPageStatus == false){
                        this.lockedContent = true
                        this.requiredContent = { date: moment(requiredDate).format('YYYY-MM-DD') + ' ' + moment(requiredDate).format('HH:mm')}
                        this.lockType = "dateDependent"
                    }
                }         
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }            
            }
        }
    },
}
</script>
